import request from "@/config/axios";

// 更新日志 VO
export interface SysUpdateLogVO {
  id: number; // 更新日志编号
  logTitle: string; // 更新日志题目
  logContent: string; // 更新日志内容
}

// 升级提示 VO
export interface UpgradeNoticeVO {
  show: boolean; // 是否展示提示
  versionCode?: string; // 版本号
  logId?: number; // 更新日志编号
  logTitle?: string; // 更新日志标题
  logContent?: string; // 更新日志内容
}

// 更新日志 API
export const SysUpdateLogApi = {
  // 查询更新日志分页
  getSysUpdateLogPage: async (params: any) => {
    return await request.get({ url: `/main/sys-update-log/page`, params });
  },

  // 查询更新日志详情
  getSysUpdateLog: async (id: number) => {
    return await request.get({ url: `/main/sys-update-log/get?id=` + id });
  },

  // 新增更新日志
  createSysUpdateLog: async (data: SysUpdateLogVO) => {
    return await request.post({ url: `/main/sys-update-log/create`, data });
  },

  // 修改更新日志
  updateSysUpdateLog: async (data: SysUpdateLogVO) => {
    return await request.put({ url: `/main/sys-update-log/update`, data });
  },

  // 删除更新日志
  deleteSysUpdateLog: async (id: number) => {
    return await request.delete({ url: `/main/sys-update-log/delete?id=` + id });
  },

  // 导出更新日志 Excel
  exportSysUpdateLog: async (params) => {
    return await request.download({ url: `/main/sys-update-log/export-excel`, params });
  },

  // 查询当前用户是否展示升级提示
  getUpgradeNoticeLatest: async (): Promise<UpgradeNoticeVO> => {
    return await request.get({ url: `/main/sys-update-log/notice/latest` });
  },

  // 标记升级提示已读
  markUpgradeNoticeRead: async (data: { versionCode?: string; logId?: number }) => {
    return await request.post({ url: `/main/sys-update-log/notice/read`, data });
  },
};
